<template>
  <div style="width: 100%">
    <div class="head">资质证件</div>
    <div
      class="rowContainer"
      v-for="(item, index) in documentList"
      :key="index"
    >
      <div class="checkTitle">
        <i
          class="el-icon-arrow-right iconFont"
          v-if="!item.selected"
          @click="
            () => {
              item.selected = !item.selected;
            }
          "
        ></i>
        <i
          class="el-icon-arrow-down iconFont"
          v-else
          @click="
            () => {
              item.selected = !item.selected;
            }
          "
        ></i>
        <el-checkbox v-model="item.selected">{{ item.title }}</el-checkbox>
      </div>
      <div :class="{ rowContent: true, fade: !item.selected }">
        <div class="row">
          <el-checkbox v-model="item.required">必填项</el-checkbox>
        </div>
        <div class="textContainer row">
          <div class="text">文字说明</div>
          <el-input
            size="mini"
            v-model="item.tipsText"
            maxlength="50"
          ></el-input>
        </div>
        <div class="row">
          <SimpleFileUpload
            :fileList="item.demo"
            accept=".jpeg,.jpg,.png,.pdf"
            @handleFileList="
              (list) => {
                getDemoFileList(item, list);
              }
            "
          />
        </div>
        <div class="row">
          <SimpleFileUpload
            :fileList="item.template"
            text="模板"
            tips="上传pdf或word，且不超过10M"
            accept=".doc,.docx,.pdf"
            @handleFileList="
              (list) => {
                getTemplateFileList(item, list);
              }
            "
          />
        </div>
        <div class="row">
          <div class="text">使用效期</div>
          <el-checkbox-group v-model="item.validityPeriodList">
            <el-checkbox label="2">本年底</el-checkbox>
            <!-- <el-checkbox label="3">3年</el-checkbox>
            <el-checkbox label="4">4年</el-checkbox>
            <el-checkbox label="5">5年</el-checkbox>
            <el-checkbox label="6">10年</el-checkbox> -->
            <el-checkbox label="1">长期</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="row">
          <div class="text">默认效期</div>
          <el-radio-group v-model="item.defaultPeriod">
            <el-radio :label="2">本年底</el-radio>
            <!-- <el-radio :label="3">3年</el-radio>
            <el-radio :label="4">4年</el-radio>
            <el-radio :label="5">5年</el-radio>
            <el-radio :label="6">10年</el-radio> -->
            <el-radio :label="1">长期</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SimpleFileUpload from "./SimpleFileUpload.vue";
export default {
  name: "QDocument",
  components: { SimpleFileUpload },
  props: {
    documentList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    getDemoFileList(item, fileList) {
      item.demo = fileList;
    },
    getTemplateFileList(item, fileList) {
      item.template = fileList;
    },
  },
};
</script>
<style scoped lang='scss'>
.rowContainer {
  padding-left: 40px;
  padding-top: 10px;
  display: flex;
  flex-flow: column;
  line-height: 30px;
}
.filedContainer {
  padding-left: 20px;
  display: flex;
  font-size: 12px;
  align-items: center;
  height: 30px;
  line-height: 30px;
  .checkTitle {
    color: red;
    display: flex;
    align-items: center;
  }
}
.text {
  color: #606266;
  font-size: 13px;
}
.rowContent {
  padding-left: 40px;
}
.row {
  padding-top: 10px;
}
.iconFont {
  font-weight: 600;
  padding-right: 10px;
  cursor: pointer;
}
.fade {
  display: none;
}
</style>